export const setUrlParams = (existingUrl: string, args: Record<string, string | string[] | number | boolean>) => {
    const urlParams = new URLSearchParams(existingUrl);
    const argKeys = Object.keys(args);
    argKeys.forEach(key => {
        urlParams.set(key, args[key].toString());
    });
    return urlParams;
};

export const getUrlParams = ({ searchString, params }: { searchString?: string; params: string[] }) => {
    const urlParams = new URLSearchParams(searchString);
    return params.map(param => urlParams.get(param));
};
